import { trans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { useSubscribe } from "core/shared";
import subscribeToOurNewsletterBg from "~/assets/images/home/subscribe-section-pattern.png";
import {
  EmailInput,
  errorToast,
  SubmitButton,
  successToast,
} from "~/design-system/components";

export function SubscribeToOurNewsletter() {
  const { handleSubscribe } = useSubscribe({
    onSuccess: () => {
      successToast(trans("subscribedSuccessfully"));
    },
    onError: (error: any) => {
      errorToast(error);
    },
  });

  return (
    <section
      className="bg-dirt-default relative py-16"
      style={{
        backgroundImage: `url(${subscribeToOurNewsletterBg})`,
      }}
    >
      <div className="container flex flex-col items-center justify-center gap-12">
        <div className="flex flex-col items-center justify-center gap-4 text-center">
          <h2 className="max-w-4xl text-3xl font-bold text-white uppercase sm:text-4xl lg:text-6xl">
            {trans("subscribeToOurNewsletter")}
          </h2>
          <p className="max-w-xl font-sans text-base text-white/75 sm:text-xl lg:text-2xl">
            {trans("stayUpToDateWithLatestNews")}
          </p>
        </div>
        <Form onSubmit={handleSubscribe} className="relative w-full max-w-lg">
          <EmailInput
            name="email"
            placeholder={trans("emailAddress")}
            classes={{
              input: "bg-white",
            }}
            required
          />
          <SubmitButton
            title={trans("subscribe")}
            className="bg-primary-light hover:bg-primary-500 disabled:hover:bg-primary-light disabled:bg-primary-light/50 absolute top-1 w-fit border px-5 py-3 lg:top-1 ltr:right-1 lg:ltr:right-1 rtl:left-1 lg:rtl:left-1"
          >
            {trans("subscribe")}
          </SubmitButton>
        </Form>
      </div>
    </section>
  );
}
